/**
 * Property floating CTA: hide while the booking section is in view; track button clicks.
 */
import { pushAnalyticsEvent } from "./analytics.js";

function initPropertyFloatingCta() {
  const cta = document.querySelector("[data-property-floating-cta]");
  const booking = document.getElementById("booking");
  if (!cta || !booking) {
    return;
  }

  const button = cta.querySelector(".property-floating-cta__button");
  if (button instanceof HTMLAnchorElement) {
    button.addEventListener("click", () => {
      pushAnalyticsEvent("property_floating_cta_click");
    });
  }

  const sync = (bookingVisible) => {
    if (bookingVisible) {
      cta.setAttribute("hidden", "");
    } else {
      cta.removeAttribute("hidden");
    }
  };

  const observer = new IntersectionObserver(
    (entries) => {
      const entry = entries[0];
      sync(Boolean(entry && entry.isIntersecting));
    },
    {
      root: null,
      threshold: 0.15,
      rootMargin: "0px 0px -10% 0px",
    },
  );

  observer.observe(booking);
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initPropertyFloatingCta);
} else {
  initPropertyFloatingCta();
}
